document.addEventListener('DOMContentLoaded', function() {
    'use strict';

    const header = document.querySelector('.header');
    const isSticky = document.querySelector('.is_sticky');
    const navbarToggle = document.querySelector('.navbar-toggle');
    const headerMenuLinks = document.querySelectorAll('.header-menu-link');
    const headerSubMenus = document.querySelectorAll('.header-sub-menu-collapse');
    const mainLogo = document.querySelector('.main_url');
    const stickyLogo = document.querySelector('.sticky_url');
    const mobileLogo = document.querySelector('.mobile_url');
    const searchForm = document.querySelector('.wp-block-search__button-only');
    const searchInput = document.querySelector('.wp-block-search__input');
    const burgerIcon = document.querySelector('.burger-icon');
    const squaredIcon = document.querySelector('.squared-icon');
    const headerMenu = document.querySelector('.header-menu');
    const dropdownToggleIcons = document.querySelectorAll('.dropdown-toggle');
    const isMobile = window.innerWidth < 768;
    let menuClosed = true;
    let clickTimeout;

    dropdownToggleIcons.forEach(function(icon) {
        // Add click event listener to each dropdown-toggle-icon
        icon.addEventListener('click', function() {
          // Find the closest .dropdown element to the clicked icon
          const dropdownMenu = this.closest('li').querySelector('.dropdown-menu');
    
          dropdownToggleIcons.forEach(function(otherIcon) {
            const otherDropdownMenu = otherIcon.closest('li').querySelector('.dropdown-menu');
            if (otherDropdownMenu !== dropdownMenu) {
                otherDropdownMenu.classList.remove('show');
            }
        });
          // Check if the dropdown menu already has the 'show' class
          if (dropdownMenu.classList.contains('show')) {
            // If it has the 'show' class, remove it to hide the menu
            dropdownMenu.classList.remove('show');
        } else {
            // If it doesn't have the 'show' class, add it to show the menu
            dropdownMenu.classList.add('show');
        }
        });
      });   

    function hideAllSubMenus() {
        headerSubMenus.forEach(menu => {
            menu.classList.add('hide-child-menus');
        });
    }

    function removePageLinks() {
        var showHeaderMenu =  headerMenu.getAttribute('data-show-mobile-id');
        if (showHeaderMenu === '') {
            headerMenuLinks.forEach(link => {
                const hasChild = link.nextElementSibling && link.nextElementSibling.classList.contains('header-sub-menu-collapse');
                if (hasChild) {
                    link.setAttribute('href', '#');
                }
            });
        }
    }

    function toggleSubMenu(target) {
        const isVisible = !target.classList.contains('hide-child-menus');
        hideAllSubMenus();
        if (!isVisible) {
            target.classList.remove('hide-child-menus');
        }
    }

    if (window.innerWidth < 768) {
        hideAllSubMenus();
        removePageLinks();
       
    }

    headerMenuLinks.forEach(link => {
        link.addEventListener('click', function() {
            const currentSubMenu = link.nextElementSibling;
            if (window.innerWidth < 768) {
                toggleSubMenu(currentSubMenu);
            }
        });
    });


    function handleScroll() {
        const isMobile = window.innerWidth < 768;
        const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
       
        if (scroll >= 100) {
            isSticky.classList.add('sticky');
            if (!header.classList.contains('header-open')) {
                if(isMobile && mobileLogo){
                    mobileLogo.style.display = 'block';
                    if (mainLogo) {
                    mainLogo.style.display = 'none';
                    }
                    if (stickyLogo) {
                    stickyLogo.style.display = 'none';
                    }
                }else{
                    if (stickyLogo) {
                    stickyLogo.style.display = 'block';
                    }
                    if (mainLogo) {
                    mainLogo.style.display = 'none';
                    }
                }
               
            } else {
                if(isMobile && mobileLogo){
                    mobileLogo.style.display = 'block';
                    if (mainLogo) {
                    mainLogo.style.display = 'none';
                    }
                    if (stickyLogo) {
                    stickyLogo.style.display = 'none';
                    }
                }else{
                    if (stickyLogo) {
                    stickyLogo.style.display = 'none';
                    }
                    if (mainLogo) {
                    mainLogo.style.display = 'block';
                    }
                }
                
            }
        } else {
            isSticky.classList.remove('sticky');
            if(isMobile && mobileLogo){
                mobileLogo.style.display = 'block';
                    mainLogo.style.display = 'none';
                    stickyLogo.style.display = 'none';
            }
            else{
                mainLogo.style.display = 'block';
            stickyLogo.style.display = 'none';
            }
            
        }
    }
    function handleResize() {
        if (window.innerWidth < 768) {
            if(mobileLogo){
                mobileLogo.style.display = 'block';
                if (mainLogo) {
                mainLogo.style.display = 'none';
                }
                if (stickyLogo) {
                stickyLogo.style.display = 'none';
                }
            }else{
                if (mainLogo) {
                mainLogo.style.display = 'block';
                }
                if (stickyLogo) {
                stickyLogo.style.display = 'none';
                }
            }
            
            
            hideAllSubMenus();
            removePageLinks();
        } else {
            if(mobileLogo){
            mobileLogo.style.display = 'none';
            }
            if (mainLogo) {
            mainLogo.style.display = 'block';
            }
            if (stickyLogo) {
            stickyLogo.style.display = 'none'; // Initially hide sticky logo on desktop view
            }
        }
    }
    handleResize(); 
    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);
    

    function openMenu() {
        const isMobile = window.innerWidth < 768;
        header.classList.add('header-open');
        if(isMobile && mobileLogo){
            mobileLogo.style.display = 'block';
            if (mainLogo) {
            mainLogo.style.display = 'none';
            }
            if (stickyLogo) {
            stickyLogo.style.display = 'none';
            }
        }else{
            if (mainLogo) {
            mainLogo.style.display = 'block';
            }
            if (stickyLogo) {
            stickyLogo.style.display = 'none';
            }
        }
        
        if (burgerIcon) {
            if(navbarToggle.getAttribute('data-remove-item')){
                burgerIcon.classList.remove('burger-icon');
                burgerIcon.classList.add('cross-icon');
            }            
            }
        
        if (squaredIcon) {
            if(navbarToggle.getAttribute('data-remove-item')){
                squaredIcon.classList.remove('squared-icon');
                squaredIcon.classList.add('cross-icon');
            }
            
        }
       
    }

    function closeMenu() {
        const isMobile = window.innerWidth < 768;
        header.classList.remove('header-open');
        if (header.classList.contains('sticky')) {
            if(isMobile && mobileLogo){
                mobileLogo.style.display = 'block';
            mainLogo.style.display = 'none';
            stickyLogo.style.display = 'none';
            }else{
                mainLogo.style.display = 'none';
            stickyLogo.style.display = 'block';
            }
            
        }
        if (navbarToggle.hasAttribute('data-id')) {
            // Get the attribute value
            const attributeValue = navbarToggle.getAttribute('data-id');
            navbarToggle.classList.remove('cross-icon');
            navbarToggle.classList.add(attributeValue); 

            if (attributeValue) {   
                navbarToggle.classList.add(attributeValue);
            }
        }
    }
    if (navbarToggle) {
    
        navbarToggle.addEventListener('click', function() {
        
        const wasMenuClosed = menuClosed;
        menuClosed = !menuClosed;
        if (wasMenuClosed) {
            openMenu();
        } else {
            closeMenu();
        }
    });
}
    function handleClickOutside(event) {

        
        // Check if the click was outside the header and menu
        if (header && !header.contains(event.target) && !navbarToggle.contains(event.target)) {
            
                if (!menuClosed) {
                    // Update wasMenuClosed based on current state before closing
                    menuClosed = true;
                    clickTimeout = setTimeout(() => {
                        closeMenu();
                    }, 100); // Small delay to ensure proper handling
                }
             // Small delay to ensure proper handling
        }
    }

    document.addEventListener('click', handleClickOutside);

    function handleClickOutsideSearch(event) {
        if (searchForm && !searchForm.contains(event.target)) {
            searchForm.classList.add('wp-block-search__searchfield-hidden');
        }
    }

    const searchButton = document.querySelector('.wp-block-search__button');
    if (searchButton) {
        searchButton.setAttribute('aria-label', 'Search');
            searchButton.setAttribute('aria-labelledby', 'searchLabel');
        searchButton.addEventListener('click', function(event) {
            event.preventDefault(); // Prevent form submission
            searchForm.classList.toggle('wp-block-search__searchfield-hidden'); // Toggle visibility of search input
            searchInput.focus(); // Focus on the search input
        });
    }

    document.addEventListener('click', handleClickOutsideSearch);

    if (searchInput) {
        searchInput.addEventListener('keydown', function(event) {
            if (event.keyCode === 13) { // Check if Enter key is pressed
                event.preventDefault(); // Prevent form submission
                const searchTerm = searchInput.value.trim();
                if (searchTerm !== '') {
                    const actionUrl = searchForm ? searchForm.action : ''; // Get the form action URL if form exists
                    const sanitizedSearchTerm = encodeURIComponent(searchTerm);
                    const searchUrl = `${actionUrl}/search-results?q=${sanitizedSearchTerm}&paging=1`; // Construct search URL
                    history.pushState({ searchTerm: sanitizedSearchTerm }, '', searchUrl);
                    window.location.replace(searchUrl); // Redirect to the search URL
                }
            }
        });
    }
});